var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "judgmentForm", attrs: { inline: true, "label-width": "150px" } },
    [
      _c("proposals"),
      _c("hr"),
      _c("internalComments"),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "danger",
                round: "",
                disabled: false
              },
              on: {
                click: function($event) {
                  _vm.releaseAudit()
                }
              }
            },
            [_vm._v("Αποδέσμευση αίτησης")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46077e0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46077e0b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/AuditorJudgement.vue
// module id = null
// module chunks = 